import { ILeadContext } from "./Interfaces/ILeadContext";
import { LeadActionKeys, LeadActionUnion } from "./Lead.Actions";

export const INITIAL_STATE: ILeadContext = {
  isLoading: false,
  result: {
    data: {
      id: "",
      recent_invoices: [],
    },
    success: false,
  },
  error: {
    error: undefined,
    success: false,
  },
};

export const LeadReducers = (
  state = INITIAL_STATE,
  action: LeadActionUnion
): ILeadContext => {
  switch (action.type) {
    case LeadActionKeys.SAVE_LEAD_SUCCESS:
      return {
        ...state,
        result: action.payload,
      };
    case LeadActionKeys.SAVE_LEAD_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case LeadActionKeys.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
};
